import type { FilterParams } from "epsm-api-types";
import { LOCAL_FIELDS } from "../../../types";
import { isTickerFilter } from "../isTickerFilter";

export function getNewsFilterByTicker(ticker: string): FilterParams {
	if (!ticker) return [];

	if (!isTickerFilter(ticker))
		return [
			{
				name: LOCAL_FIELDS.COMPANY_TICKER,
				condition: "eq",
				value: ticker,
			},
		];

	return [];
}
